export default __webpack_public_path__ + "static/media/fleetBook_light_disabled.ff098281.png";